import { selectLocationStatus, selectLocationPlaces } from 'containers/Maps/Result/locationSlice'
import NewPlaceElementForList from 'containers/Maps/Result/NewPlaceElementForList'
import { selectPlaces as selectMapPlaces } from 'containers/Maps/Map/mapSlice'
import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import SkeletonElement from 'containers/Maps/Result/SkeletonElement'
import AutomationPopup from 'containers/Maps/Popups/AutomationPopup'
import { addFilters } from 'containers/Maps/menu/filtersSlice'
import { Fragment, useEffect, useRef, useState } from 'react'
import SortSelect from 'containers/Maps/Result/SortSelect'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import ObjectDetails from '../ObjectDetails'
import { useSelector } from 'react-redux'
import { useReduxDispatch } from 'store'
import { STATUS } from 'utils/constants'
import MapDetails from '../MapDetails'
import Error from 'components/Error'

const List = () => {
  const mapPlaces = useSelector(selectMapPlaces)
  const status = useSelector(selectLocationStatus)
  const places = useSelector(selectLocationPlaces)
  const [isNarrow, setIsNarrow] = useState(false)

  const { popup } = usePopupState()
  const { pathname } = useLocation()
  const { placeId } = useParams<{ placeId?: string }>()
  const placeData = findPlaceData(placeId, mapPlaces, places)

  const { goBack, push } = useHistory()
  const { t } = useTranslation('map')
  const dispatch = useReduxDispatch()

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    containerRef.current?.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [pathname])

  //Dynamiczna zmiana ilości kolumn z lewej strony
  useEffect(() => {
    const element = containerRef.current
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        setIsNarrow(entry.contentRect.width < 500)
      }
    })

    if (element) {
      observer.observe(element)
    }

    return () => {
      observer.disconnect()
    }
  }, [pathname])


  if (pathname.includes('mapdetails')) {
    return (
      <MapDetails />
    )
  }

  return (
    <>
      {(popup as any)?.type === 'warehouse_attr' && (popup as any)?.place_attrs && <WarehouseAttrPopup body={(popup as any)?.place_attrs} />}
      {(popup as any)?.type === 'automation' && (popup as any)?.automation && <AutomationPopup body={(popup as any)?.automation} />}
      {placeId
        ? <div className="search__left" ref={containerRef}>
          <div className="search__left__title">
            <div>
              <h2 className='--secFont'>{placeData?.placeName}</h2>
              <p>{placeData?.city}, {placeData?.street} {placeData?.estateNumber}</p>
            </div>
            <ArrowBtn text={t('backToList')} action={goBack} className='--reverse --black' />
          </div>
          <div className="search__left__content">
            <ObjectDetails
              key={placeId}
              placeId={placeId}
              data={placeData}
            />
          </div>
        </div>
        : <div className="search__left" ref={containerRef}>
          <div className="search__left__title">
            <div>
              <h2>
                {places?.filteredAndLocalized
                  ? places?.filteredAndLocalized?.length > 0
                    ? `${t('foundItems')} (${places.filteredAndLocalized.length})`
                    : t('noResults')
                  : status === STATUS.pending
                    ? t('loading')
                    : ''}
              </h2>
            </div>
            {getAmountOfPlaces(places) > 0
              ? <SortSelect />
              : <button
                className='btn--clear'
                onClick={() => {
                  dispatch(addFilters({}))
                }}>
                {t('clearFilters')}
              </button>}
          </div>
          <div
            className="search__left__content"
            style={{
              gridTemplateColumns: isNarrow ? "1fr" : "1fr 1fr"
            }}>
            {status === STATUS.pending
              ? [1, 2, 3].map(e => <SkeletonElement key={e} isDesktop />)
              : status === STATUS.succeed
                ? Object.entries(places).map(([k, _v]) => {
                  const v = _v as any[]
                  const title = k === 'filtered' && v.length > 0 ? (
                    <div className='list__header'>
                      <span>{t('seeOtherLocations')}</span>
                      <i className='icon icon--chevron-down' />
                    </div>
                  ) : k === 'localized' && v.length > 0 ? (
                    <div className='list__header'>
                      <span>{t('seeOtherOptions')}</span>
                      <i className='icon icon--chevron-down' />
                    </div>
                  ) : false

                  const elements = v.map((e, idx) => <NewPlaceElementForList
                    data={e}
                    key={idx}
                    navigate={push}
                  />)

                  return <Fragment key={k}>
                    {title}
                    {v.length > 0 && elements}
                  </Fragment>
                }) : <Error />}
          </div>
        </div>}
    </>
  )
}

const findPlaceData = (placeId?: string, mapPlaces?: locations.Location[], places?: locations.LocationPlaces) => {
  if (!placeId) return
  if (mapPlaces) {
    const place = mapPlaces?.find((place) => place?.id === placeId)
    if (place) return place
  }
  if (places) {
    for (const key in places) {
      const place = places[key as keyof locations.LocationPlaces].find(place => place.id === placeId)
      if (place) return place
    }
  }
}

const getAmountOfPlaces = (places?: locations.LocationPlaces) => {
  if (!places) return 0
  return Object.values(places).reduce((r, e) => r + e.length, 0)
}

export default List